export enum ErrorsEnum {
  Error404 = 'błąd 404',
  Error404BackButton = 'Wróć do poprzedniej strony',
  Error404Description = 'Przepraszamy, podana strona nie została odnaleziona.',
  Error404HomeButton = 'Przejdź do Strony Głównej',
  SomeInformationNotGet = 'Nie udało się pobrać pewnych informacji',
  UfgErrorHeading = 'Uwaga!',
  UfgErrorText1 = ' Obecnie obserwujemy problemy ubezpieczycieli z\xa0pozyskaniem historii ubezpieczenia z\xa0bazy UFG.',
  UfgErrorText2 = 'Ranking ofert może nie być kompletny. Wróć do nas później. Przepraszamy za\xa0niedogodności.',
  UfgErrorTextLoader = 'Obecnie obserwujemy ogólnopolski problem z\xa0pozyskaniem historii ubezpieczenia z\xa0bazy UFG przez\xa0firmy ubezpieczeniowe.',
}
